import {
  FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isTableConfigLoading = (state) =>
    ArrayContains(state.table.openRequests, [
        FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST,
    ]);
